import { View } from "../Base";
import { Popover, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useEffect, useState } from "react";
import { getValueLabelValue } from "../../utils/timeSlider";
import { useDispatch, useSelector } from "react-redux";
import {
  getRegularRoutersByTimeBands,
  getMatrixProfileType,
  driversSelector,
} from "../../reducers/matrixProfile/selectors";
import { selectedCollectionTabSelector } from "../../reducers/ownApp/selectors";
import RouteLabel from "../RouteCard/RouteLabel";
import { onRouteCLick } from "../../reducers/ownApp/thunkActions";

const useStyles = makeStyles({
  routesContainer: {
    minWidth: "250px",
    maxWidth: "350px",
    overflowX: "auto",
    height: "300px",
    overflowY: "auto",
    padding: "12px",
  },
  header: {
    padding: "12px 12px 5px 12px",
    fontWeight: "bold",
  },
  driverName: {
    fontSize: "13px",
    display: "inline",
    marginLeft: "12px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  routeLabel: {
    display: "inline-block",
  },
  routeCell: {
    display: "flex",
    paddingTop: "5px",
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  },
});

const RouteListPopover = ({ anchorEl, onClose, waveSelected }) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const [listOfRoutes, setListOfRoutes] = useState([]);
  const drivers = useSelector(driversSelector);
  const routesByTimeBand = useSelector(getRegularRoutersByTimeBands);
  const planType = useSelector(getMatrixProfileType);
  const collectionType = useSelector(selectedCollectionTabSelector);

  useEffect(() => {
    if (!routesByTimeBand || !routesByTimeBand[waveSelected]) {
      return setListOfRoutes([]);
    }

    setListOfRoutes(
      routesByTimeBand[waveSelected].sort((a, b) =>
        a.routeCode < b.routeCode ? -1 : 1
      )
    );
  }, [routesByTimeBand, waveSelected]);

  const onClickRoute = (route) => {
    onClose();
    setImmediate(() => dispatch(onRouteCLick(route)));
  };

  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <View className={styles.container}>
        <View className={styles.header}>
          <Typography className={styles.componentTitle}>
            {waveSelected === "final"
              ? "Final Wave"
              : getValueLabelValue(waveSelected)}{" "}
            Routes
          </Typography>
        </View>
        <View className={styles.routesContainer}>
          <View>
            {listOfRoutes.map((route) => (
              <View key={route.routeCode}>
                <View className={styles.routeCell}>
                  <View className={styles.routeLabel}>
                    <RouteLabel
                      route={route}
                      planType={planType}
                      collectionType={collectionType}
                      onClick={() => onClickRoute(route)}
                    />
                  </View>
                  <Typography className={styles.driverName}>
                    {(
                      drivers[route.driverCode]?.driverName || ""
                    ).toUpperCase()}
                  </Typography>
                </View>
              </View>
            ))}
          </View>
        </View>
      </View>
    </Popover>
  );
};

export default RouteListPopover;
